import {
  getSessionCount, incrementSessionCount,
} from '@scaler_landing/utils/sessionCount';
import { isIOS } from '@common/utils/platform';

const PLAYSTORE_AD_ID = 'playstore-mobile-ad';
const SESSIONS_LIMIT = 2;

function handleAdOpen() {
  sessionStorage.setItem(PLAYSTORE_AD_ID, 'true');
  incrementSessionCount(PLAYSTORE_AD_ID);

  window.TrackingHelper.track('eventFormatter', {
    element: 'app_mkrt',
    tagName: 'app_mkrt',
    eventType: 'view',
  });
}

function shouldShowAd() {
  const sessionCount = getSessionCount(PLAYSTORE_AD_ID);
  return sessionCount < SESSIONS_LIMIT
         && !sessionStorage.getItem(PLAYSTORE_AD_ID);
}

function PlaystoreMobileAd() {
  const element = document.getElementById(PLAYSTORE_AD_ID);
  if (element && shouldShowAd() && window.innerWidth <= 768 && isIOS()) {
    handleAdOpen();
    element.style.display = 'flex';
  }
}

export default { initialize: PlaystoreMobileAd };
